import { useDebounce } from '../hooks/UNSAFE_useDebounce';
import { useTranslationBundle } from '../hooks/UNSAFE_useTranslationBundle';
import { BundleType } from '../resources/nls/bundle';
import { LiveRegion } from '../UNSAFE_LiveRegion';
import { TestIdProps } from '#hooks/UNSAFE_useTestId';

type Props = TestIdProps & {
  isMaxLengthExceeded: boolean;
  maxLength: number;
  valueLength?: number;
};

const MAX_LENGTH_UPDATE_DELAY = 500;

export function MaxLengthLiveRegion({
  isMaxLengthExceeded,
  maxLength,
  testId,
  valueLength = 0
}: Props) {
  // Comment copied from InputBase.js in Big JET:
  // Only update the aria-live div when the user has paused for more than
  // 500 milliseconds. That way, we avoid queued up aria-live messages which
  // would be annoying and not helpful. The 500ms was agreed upon in the
  // accessibility review meeting.
  const debouncedRemainingChars = useDebounce(maxLength - valueLength, MAX_LENGTH_UPDATE_DELAY);
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  const maxLengthExceededTranslatedString = translations.formControl_maxLengthExceeded({
    MAX_LENGTH: `${maxLength}`
  });
  const remainingCharsTranslatedString = translations.formControl_maxLengthRemaining({
    CHARACTER_COUNT: `${debouncedRemainingChars}`
  });

  return (
    <>
      <LiveRegion testId={testId ? testId + '_remainingChars' : undefined}>
        {remainingCharsTranslatedString}
      </LiveRegion>
      {isMaxLengthExceeded && (
        <LiveRegion testId={testId ? testId + '_exceeded' : undefined} type="assertive">
          {maxLengthExceededTranslatedString}
        </LiveRegion>
      )}
    </>
  );
}
